import { render } from "./modifsProgramsPopup.vue?vue&type=template&id=f06f9f48&scoped=true"
import script from "./modifsProgramsPopup.vue?vue&type=script&lang=js"
export * from "./modifsProgramsPopup.vue?vue&type=script&lang=js"

import "./modifsProgramsPopup.vue?vue&type=style&index=0&id=f06f9f48&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f06f9f48"]])

export default __exports__